import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import { checkPiAnswer, pick, range, renderPiAnswer, renderPiUserAnswer, SolidPiInput } from "../commonSolidPi";

export function generateTask() {
  const r = pick(range(2, 9));
  const h = pick([3, 6, 9, 12]);
  const k = (r * r * h) / 3;
  return { type: "ConeVolumeTask", data: { r, h, k, numeric: k * Math.PI } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Oblicz objętość stożka o promieniu podstawy <InlineMath math={`${data.r}`} /> i wysokości{" "}
      <InlineMath math={`${data.h}`} />.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <SolidPiInput value={userAnswer} onChange={onChange} disabled={disabled} label="V" />;
}

export function checkAnswer({ data }, userAnswer) {
  return checkPiAnswer(data.numeric, userAnswer);
}

export function renderAnswer({ data }) {
  return renderPiAnswer("V", data.k);
}

export function renderUserAnswer(userAnswer) {
  return renderPiUserAnswer(userAnswer, "V");
}

export function renderExplanation({ data }) {
  const { r, h, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Korzystamy ze wzoru na objętość stożka.</p>
      <BlockMath math={`V=\\frac{1}{3}\\pi r^2h`} />
      <p><strong>Krok 2.</strong> Podstawiamy dane.</p>
      <BlockMath math={`V=\\frac{1}{3}\\pi\\cdot ${r}^2\\cdot ${h}=${k}\\pi`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`V=${k}\\pi`} />.</p>
    </div>
  );
}
